import moment from 'moment';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getLastRefreshDate } from '../DeviceHealthService';
import { getISTDate } from '../../../../../Shared/common';

const DeviceHealthContext = createContext();

export const DeviceHealthContextProvider = ({ children }) => {

    const [GlobalFilter, setGlobalFilters] = useState({
        search: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        city: [],
        depot: [],
        contract: []
    });

    // shown as the date badge in the vehicle popovers
    const [lastRefreshDate, setLastRefreshDate] = useState(null);

    useEffect(() => {
        getLastRefreshDate()
            .then(res => {
                let date= moment(res?.lastRefreshDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                setLastRefreshDate(res?.lastRefreshDate || null)
                setGlobalFilters(prev => ({
                    ...prev,
                      startDate: getISTDate(date), 
                      endDate: getISTDate(date)
                }))

            }).catch(err=>{})
    }, [])

    return (
        <DeviceHealthContext.Provider value={{ GlobalFilter, setGlobalFilters, lastRefreshDate }}>
            {children}
        </DeviceHealthContext.Provider>
    );
};

export const useDeviceHealthContextData = () => useContext(DeviceHealthContext); 